import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import TimbradoSftpList from './list/TimbradoSftpList';
import TimbradoSftpSearch from './list/components/TimbradoSftpSearch';
import TimbradoSftpActions from './list/components/TimbradoSftpActions';
import TimbradoSftpItemActions from './list/components/TimbradoSftpItemActions';
import TimbradoSftpFilterByType from './list/components/TimbradoSftpFilterByType';
import TimbradoSftpFilterByStatus from './list/components/TimbradoSftpFilterByStatus';

class TimbradoSftp extends Component {
  state = {
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    window.setAppTitle('Timbrado Tickets');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/modulos/timbrado-sftp/${data.id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  render() {
    const { selectedRowKeys, selectedRows } = this.state;

    return (
      <div>
        <Row className="mb-1">
          <Col
            sm="12"
            md="9"
          >
            {selectedRowKeys.length === 0 && <TimbradoSftpSearch />}

            {selectedRowKeys.length > 0 && (
              <TimbradoSftpItemActions
                selectedRowKeys={selectedRowKeys}
                selectedRows={selectedRows}
              />
            )}
          </Col>
          <Col
            sm="12"
            md="3"
            className="text-right"
          >
            <TimbradoSftpActions />
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="float-left">
              <TimbradoSftpFilterByType />
              <TimbradoSftpFilterByStatus />
            </div>
          </Col>
        </Row>

        {Guardian.allows('timbrado.sftp.listar.archivos') && (
          <TimbradoSftpList
            onRowClick={this.handleOnRowClick}
            onRowSelectionChange={this.handleOnRowSelectionChange}
          />
        )}
      </div>
    );
  }
}

export default TimbradoSftp;
